import removeDiacritics from "@gef-ui/utils/removeDiacritics";
import invariant from 'invariant';
import test from "ramda/es/test";
import accents from 'remove-accents';
function filterLevenshteinDistance(key, searchText) {
    const current = [];
    let prev = undefined;
    let value;
    for(let i = 0; i <= key.length; i++){
        for(let j = 0; j <= searchText.length; j++){
            if (i && j) {
                if (searchText.charAt(j - 1) === key.charAt(i - 1)) {
                    value = prev;
                } else {
                    value = Math.min(current[j], current[j - 1], prev) + 1;
                }
            } else {
                value = i + j;
            }
            prev = current[j];
            current[j] = value;
        }
    }
    return current.pop();
}
const hasNoDiacritics = test(/^[a-zA-Z]+$/);
const caseSensitive = (value, searchText)=>value !== '' && value.indexOf(searchText) !== -1;
const caseSensitiveWithoutDiacritics = (value, searchText)=>value !== '' && removeDiacritics(value).indexOf(hasNoDiacritics(searchText) ? searchText : removeDiacritics(searchText)) !== -1;
const caseInsensitive = (value, searchText)=>value !== '' && value.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
const caseInsensitiveWithoutDiacritics = (value, searchText)=>value !== '' && removeDiacritics(value).toLowerCase().indexOf(hasNoDiacritics(searchText) ? searchText.toLowerCase() : removeDiacritics(searchText).toLowerCase()) !== -1;
const startsWith = (value, searchText)=>value !== '' && value.toLowerCase().startsWith(searchText.toLowerCase());
const levenshteinDistance = (distanceLessThan)=>{
    if (distanceLessThan === undefined) {
        return filterLevenshteinDistance;
    }
    invariant(typeof distanceLessThan === 'number', 'Error: filterLevenshteinDistance is a filter generator, not a filter!');
    return (s, k)=>filterLevenshteinDistance(k, s) < distanceLessThan;
};
const fuzzy = (key, searchText)=>{
    const compareString = accents.remove(key.toLowerCase());
    const searchTextFinal = accents.remove(searchText.toLowerCase());
    let searchTextIndex = 0;
    for(let index = 0; index < key.length; index++){
        if (compareString[index] === searchTextFinal[searchTextIndex]) {
            searchTextIndex += 1;
        }
    }
    return searchTextIndex === searchText.length;
};
export default {
    caseInsensitive,
    caseInsensitiveWithoutDiacritics,
    caseSensitive,
    caseSensitiveWithoutDiacritics,
    levenshteinDistance,
    fuzzy,
    startsWith,
    hasNoDiacritics
};
